<template>
  <div>
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <div style="text-align: center;font-size: 20px;">
      <button
        style="width:500px;height:100px;background-color:orange;margin:auto"
        @click="print()"
      >
        طباعة تقرير متوسط سدادات ومبيعات عملاء من الي
        <br />
        {{ $route.query.name }}
      </button>
    </div>
    <div id="printMe" style="display:none">
      <div style="direction:rtl;float:right">
        <p
          style="text-align:center;font-size:22px;font-weight:bold;margin-bottom:15px;text-decoration:underline;"
        >
          تقرير متوسط سدادات ومبيعات عملاء لـ {{ $route.query.name }} من الي
          {{ $route.query.from }} الي
          {{ $route.query.to }}
        </p>
        <div class="row">
          <div class="col-sm-4" style="border-left:1px dotted">
            <div style="float:right;">
              <img
                style="width:100%;height:100px;"
                src="../../../../public/images/color.png"
                alt="Accurate"
              />
            </div>
          </div>
          <div class="col-sm-8">
            <div style="float:right;font-size:17px;text-align:right">
              <p>
                <span style="font-weight:bold;">مجموع متوسطات السدادات : </span>
                <span> {{ all_sadads }} </span>
              </p>
              <p>
                <span style="font-weight:bold;"> مجموع متوسطات المبيعات: </span>
                <span> {{ all_sales }} </span>
              </p>
              <p>
                <span style="font-weight:bold;"> مجموع متوسطات المرتجعات: </span>
                <span> {{ all_rebacks }} </span>
              </p>
              <p>
                <span style="font-weight:bold;"> عدد الشهور: </span>
                <span> {{ months }} </span>
              </p>
            </div>
          </div>
        </div>
        <hr />
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">كود العميل</th>
              <th scope="col">اسم العميل</th>
              <th scope="col">الرصيد الافتتاحي</th>
              <th scope="col">الحد الائتماني</th>
              <th scope="col">مجموعات السدادات</th>
              <th scope="col">مجموع المبيعات</th>
              <th scope="col">مجموع المرتجعات</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas" :key="f.id">
              <th scope="row">{{ f.client.code }}</th>
              <td>{{ f.client.name }}</td>
              <td>{{ f.client.rasid_efttahi }}</td>
              <td>{{ f.client.had_eetmani }}</td>
              <td>{{ f.sadads }}</td>
              <td>{{ f.sales }}</td>
              <td>{{ f.rebacks }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { ClientSadadSalesAverageReport } from "../../config/apiRoute.js";
import { appUrl } from "../../config/apiConfig.js";
export default {
  data() {
    return {
      loading: true,
      fatworas: [],

      all_sadads: "",
      all_sales: "",
      all_rebacks: "",
      months: "",
      appUrl: ""
    };
  },
  mounted() {
    this.appUrl = appUrl;
    this.get_data();
  },
  methods: {
    print() {
      this.$htmlToPaper("printMe");
    },
    get_data() {
      var frmData = new FormData();
      frmData.append("branch_id", this.$route.query.id);
      frmData.append("date_from", this.$route.query.from);
      frmData.append("date_to", this.$route.query.to);
      ClientSadadSalesAverageReport(frmData).then(response => {
        response.data.myarr.length > 0
          ? (this.fatworas = response.data.myarr)
          : (this.fatworas = []);
        this.all_sadads = response.data.all_sadads;
        this.all_sales = response.data.all_sales;
        this.all_rebacks = response.data.all_rebacks;
        this.months = response.data.months;

        this.loading = false;
        setTimeout(() => {
          this.print();
        }, 200);
      });
    }
  }
};
</script>
